import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export class AttributePrototype {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  defaultValueType!: number;
  @IsOptional()
  @IsString()
  @Expose()
  defaultLabel!: string | null;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  attributeSource!: string | null;
}

export type AttributePrototypesList = Array<AttributePrototypeDetailed>;

export class Attribute {
  @IsString()
  @Expose()
  label!: string;
  @IsOptional()
  @IsString()
  @Expose()
  value!: string;
}

export class AttributePrototypeDetailed extends AttributePrototype {
  @IsString()
  @Expose()
  code!: string;
}
